import { RoleCategory, RoleFunction } from '../constants/projectUserRoles';

export const checkRoleCategory = (roleFunction: RoleFunction) => {
  const isAdmin = [RoleFunction.ROLE_ADMIN, RoleFunction.ROLE_ACCEPTING, RoleFunction.ROLE_SCIENTIFIC].includes(roleFunction);
  return isAdmin ? RoleCategory.ADMIN : RoleCategory.USER;
}

export const checkPermission = (roleFunction: RoleFunction, rolesPermission: RoleFunction[]) => {
  return rolesPermission.includes(roleFunction);
}



